import { createFeatureSelector } from '@ngrx/store';
import { MerchantDocumentState } from '../reducers/merchant-document.reducer';

export const selectMerchantDocument = createFeatureSelector<MerchantDocumentState>('merchantDocument');
